module.exports = __webpack_public_path__ + "img/img_xiangguanchanping.a055837e.png";